import { enableProdMode } from "@angular/core";
import { platformBrowser } from "@angular/platform-browser";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./App/AppModule";
import { environment } from "./environments/environment";
import { registerLocaleData } from "@angular/common";
import localeNZ from "@angular/common/locales/en-NZ";

registerLocaleData(localeNZ, "en-NZ");

if (environment.production) {
	enableProdMode();

	platformBrowser()
		.bootstrapModule(AppModule)
		.catch(err => console.error(err));
}
else {
	platformBrowserDynamic() // platformBrowserDynamic used to support JIT compiling templates in the browser
		.bootstrapModule(AppModule)
		.catch(err => console.error(err));
}
